// const isDev = import.meta.env.DEV

// export const baseUrl = isDev
//   ? 'http://localhost:8000/api'
//   : 'https://peerreviewbackend.sealosbja.site/api'
export const baseUrl = 'https://peerfeedback.rdc.nie.edu.sg/api'
